import { gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';

export const generateFloor: DocumentNode = gql`
  mutation generateFloor($sessionData: SessionDataInput, $quoteOption: Int) {
    generateFloor(sessionData: $sessionData, quoteOption: $quoteOption)
  }
`;

export const exportCadScript: DocumentNode = gql`
  mutation exportCadScript($sessionData: SessionDataInput, $quoteOption: Int) {
    exportCadScript(sessionData: $sessionData, quoteOption: $quoteOption)
  }
`;

export const generateQuote: DocumentNode = gql`
  mutation generateQuote($sessionData: SessionDataInput, $quoteOption: Int) {
    generateQuote(sessionData: $sessionData, quoteOption: $quoteOption)
  }
`;

export const generateCalcs: DocumentNode = gql`
  mutation generateCalcs($sessionData: SessionDataInput, $quoteOption: Int) {
    generateCalcs(sessionData: $sessionData, quoteOption: $quoteOption)
  }
`;

export const exportQd3: DocumentNode = gql`
  mutation exportQd3($sessionData: SessionDataInput, $quoteOption: Int) {
    exportQd3(sessionData: $sessionData, quoteOption: $quoteOption)
  }
`;

export const generateBudgetQuote: DocumentNode = gql`
  mutation generateBudgetQuote(
    $sessionData: SessionDataInput
    $quoteData: QuoteDataInput
  ) {
    generateBudgetQuote(sessionData: $sessionData, quoteData: $quoteData)
  }
`;

export const generateDistributorQuote: DocumentNode = gql`
  mutation generateDistributorQuote(
    $sessionData: SessionDataInput
    $quoteOption: Int
  ) {
    generateDistributorQuote(
      sessionData: $sessionData
      quoteOption: $quoteOption
    )
  }
`;

export const emailQuote: DocumentNode = gql`
  mutation emailQuote(
    $quoteOption: Int
    $sessionData: SessionDataInput
    $toEmailAddress: String
  ) {
    emailQuote(
      quoteOption: $quoteOption
      sessionData: $sessionData
      toEmailAddress: $toEmailAddress
    )
  }
`;

export const importPolyline: DocumentNode = gql`
  mutation importPolyline(
    $sessionData: SessionDataInput
    $quoteOption: Int
    $script: String
  ) {
    importPolyline(
      sessionData: $sessionData
      quoteOption: $quoteOption
      script: $script
    )
  }
`;
